import { computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { IOverlappingCampaignsCluster } from '@/models/overlapping-campaigns.interface';
import store from '@/store';

export default class OverlappingCampaignsModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	public overlappingCampaignsCluster = computed((): IOverlappingCampaignsCluster | null => {
		return store.getters.overlappingCampaignsCluster();
	});

	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	public closeModal(): void {
		store.mutations.setOverlappingCampaignsCluster(null);
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'OverlappingCampaignsModalWrapper',
			destroyOnClose: false,
			onClose: this.closeModal.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}
}
